export default "__VITE_ASSET__IOCMraSO__"